import { render, staticRenderFns } from "./OrderRDItemEdit.vue?vue&type=template&id=1e7d53b8&scoped=true"
import script from "./OrderRDItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderRDItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderRDItemEdit.vue?vue&type=style&index=0&id=1e7d53b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d53b8",
  null
  
)

export default component.exports